import { ReactElement, ReactNode } from 'react';
import { PlanEntitlementKey } from '../../api/graphql/generated';
import { useMachineContext } from '../../pages/machine/machine-context-provider';
import { useHasAssignedPlanLicense } from '../plan/plan-hooks';
import { PaywallBlur } from './paywall-blur';

interface MachineLicensePaywallBlurProps {
  planEntitlementKey: PlanEntitlementKey;
  blurId?: string;
  children?: ReactNode;
  disableBlur?: boolean;
  customAction?: (props: { presentUpgrade: () => void }) => ReactElement;
  disableClick?: boolean;
}

const MachineLicensePaywallBlur = (
  props: MachineLicensePaywallBlurProps
): ReactElement => {
  const { machine } = useMachineContext();
  const isMachineLicensed = useHasAssignedPlanLicense({
    key: props.planEntitlementKey,
    assignedTo: machine.id,
  });

  return (
    <PaywallBlur
      {...props}
      isFeatureAvailable={(hasEntitlement) => {
        return hasEntitlement && isMachineLicensed;
      }}
    />
  );
};

export { MachineLicensePaywallBlur };
